var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600px", persistent: "" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title"),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.items,
                          disabled: _vm.rules.id === 1,
                          "item-text": "string",
                          label: "Select Item(s):",
                          "return-object": "",
                          multiple: "",
                          "small-chips": "",
                          "deletable-chips": "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model,
                          callback: function ($$v) {
                            _vm.model = $$v
                          },
                          expression: "model",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.forms.length
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-simple-table",
                            {
                              staticStyle: {
                                "max-height": "300px",
                                "margin-top": "16px",
                                overflow: "auto",
                              },
                              attrs: { dense: "" },
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v("Item"),
                                  ]),
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v("State"),
                                  ]),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "text-left",
                                      staticStyle: { width: "120px" },
                                    },
                                    [_vm._v("Amount")]
                                  ),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(_vm.forms, function (f) {
                                  return _c("tr", { key: f.string }, [
                                    _c("td", [_vm._v(_vm._s(f.string))]),
                                    _c(
                                      "td",
                                      [
                                        _c("r-item-state-dropdown", {
                                          staticStyle: { "margin-top": "-4px" },
                                          attrs: {
                                            model: f.state,
                                            "hide-label": true,
                                          },
                                          on: {
                                            "update:model": function ($event) {
                                              return _vm.$set(
                                                f,
                                                "state",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c("v-text-field", {
                                          staticStyle: { "margin-top": "-4px" },
                                          attrs: {
                                            "hide-details": "",
                                            type: "number",
                                            min: "0",
                                            dense: "",
                                          },
                                          on: {
                                            keydown: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              $event.stopPropagation()
                                            },
                                          },
                                          model: {
                                            value: f.amount,
                                            callback: function ($$v) {
                                              _vm.$set(f, "amount", _vm._n($$v))
                                            },
                                            expression: "f.amount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                }),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }